import CloseOutlined from '../../assets/common/CloseOutlined';
import SaveOutlined from '../../assets/common/SaveOutlined';
import UpdateTextModal from '../../CommonComponents/UpdateTextModal';

const CreateFolderModal = ({ isOpen, onClose, onSave, loading }) => {
  const renderHeader = () => {
    return (
      <div className='flex mb-16' style={{ justifyContent: 'space-between' }}>
        <h3>Create new folder</h3>
        <button onClick={onClose}>
          <CloseOutlined size={24} />
        </button>
      </div>
    );
  };

  const renderLabel = () => {
    return (
      <div
        className='mt-16'
        style={{
          borderRadius: '8px',
          border: '1px solid var(--border-color)',
          padding: '1rem',
          backgroundColor: 'var(--grey-3)',
        }}
      >
        <div>Use folders to</div>
        <ul style={{ paddingLeft: '1rem', color: 'var(--grey-9)' }}>
          <li style={{ listStyleType: 'disc' }}>Organise your files.</li>
          <li style={{ listStyleType: 'disc' }}>Chat with multiple files at same time.</li>
        </ul>
      </div>
    );
  };

  return (
    <UpdateTextModal
      isOpen={isOpen}
      renderHeader={renderHeader}
      renderLabel={renderLabel}
      onClose={onClose}
      onSave={onSave}
      submitButtonProps={{ icon: <SaveOutlined size={14} /> }}
      loading={loading}
    />
  );
};

export default CreateFolderModal;
